var _g, _ellipse, _line, _g2, _line2, _line3, _ellipse2, _g3, _line4, _line5, _ellipse3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 58,
    viewBox: "0 0 74 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_85_6796)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.9693,
    height: 50.3803,
    rx: 3,
    transform: "matrix(0.985004 -0.172531 0.172015 0.985094 1 6.20581)",
    fill: "#FEFBFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.867764,
    y: 0.609422,
    width: 34.4693,
    height: 48.8803,
    rx: 2.25,
    transform: "matrix(0.985004 -0.172531 0.172015 0.985094 0.908183 6.36461)",
    stroke: "#002C71",
    strokeWidth: 1.5
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.1108,
    cy: 28.3929,
    rx: 7.62451,
    ry: 7.6505,
    fill: "#F0F0F5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 3.84226,
    y2: -0.75,
    transform: "matrix(0.99065 -0.136427 0.137162 0.990549 6.35742 10.7388)",
    stroke: "#002C71",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_85_6796)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.9692,
    height: 50.3804,
    rx: 3,
    transform: "matrix(0.984902 0.173114 -0.175619 0.984458 37.5732 0.0872803)",
    fill: "#FEFBFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.606962,
    y: 0.868179,
    width: 34.4692,
    height: 48.8804,
    rx: 2.25,
    transform: "matrix(0.984902 0.173114 -0.175619 0.984458 37.7349 -0.00430011)",
    stroke: "#002C71",
    strokeWidth: 1.5
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 3.8423,
    y2: -0.75,
    transform: "matrix(0.984888 0.173188 -0.174109 0.984726 40.1992 6.55737)",
    stroke: "#002C71",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 3.8423,
    y2: -0.75,
    transform: "matrix(0.984888 0.173188 -0.174109 0.984726 56.0928 49.1095)",
    stroke: "#002C71",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.62817,
    cy: 7.64677,
    rx: 7.62817,
    ry: 7.64677,
    transform: "matrix(0.926445 -0.376431 0.378201 0.925723 40.623 23.4261)",
    fill: "#F0F0F5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_85_6796)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5225,
    y: 0.0753174,
    width: 35.9722,
    height: 50.3762,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.2725,
    y: 0.825317,
    width: 34.4722,
    height: 48.8762,
    rx: 2.25,
    stroke: "#002C71",
    strokeWidth: 1.5
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 23.8477,
    y1: 4.76172,
    x2: 26.9224,
    y2: 4.76172,
    stroke: "#002C71",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 46.7207,
    y1: 45.9944,
    x2: 49.7954,
    y2: 45.9944,
    stroke: "#002C71",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.4403,
    cy: 25.7052,
    rx: 14.1053,
    ry: 14.1534,
    fill: "#E1F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1681 35.1186V35.9703H24.2979V35.1186H25.5765V20.2224C25.5765 20.1657 25.5878 20.1116 25.6088 20.059C25.6306 20.0072 25.6613 19.9611 25.7016 19.9215C25.7412 19.881 25.7873 19.8503 25.8398 19.8293C25.8923 19.8074 25.9464 19.7961 26.0029 19.7961H30.6917V13.412C30.6917 13.3554 30.7022 13.3012 30.724 13.2494C30.7458 13.1969 30.7765 13.1508 30.8169 13.1111C30.8564 13.0715 30.9025 13.0408 30.955 13.0189C31.0067 12.9971 31.0616 12.9866 31.1181 12.9866H41.3478C41.4043 12.9866 41.4584 12.9971 41.5109 13.0189C41.5634 13.0408 41.6095 13.0715 41.649 13.1111C41.6894 13.1508 41.7201 13.1969 41.7419 13.2494C41.7629 13.3012 41.7742 13.3554 41.7742 13.412V19.7961H46.463C46.5195 19.7961 46.5736 19.8074 46.6261 19.8293C46.6778 19.8503 46.7239 19.881 46.7643 19.9215C46.8038 19.9611 46.8353 20.0072 46.8563 20.059C46.8781 20.1116 46.8895 20.1657 46.8895 20.2224V35.1186H48.1681ZM30.6917 20.6478H26.4294V35.1186H30.6917V20.6478ZM40.9213 13.8375H31.5438V35.1186H40.9213V13.8375ZM46.0365 20.6478H41.7742V35.1186H46.0365V20.6478Z",
    fill: "#002C71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0303 29.4502C34.0303 29.2787 34.1691 29.1396 34.3404 29.1396H38.5276C38.6989 29.1396 38.8378 29.2787 38.8378 29.4502V35.6621C38.8378 35.8336 38.6989 35.9726 38.5276 35.9726H34.3404C34.1691 35.9726 34.0303 35.8336 34.0303 35.6621V29.4502ZM34.6506 29.7608V35.3515H38.2174V29.7608H34.6506Z",
    fill: "#002C71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9453 15.1631C32.9453 14.9916 33.0842 14.8525 33.2555 14.8525H35.1164C35.2877 14.8525 35.4266 14.9916 35.4266 15.1631V17.0267C35.4266 17.1982 35.2877 17.3373 35.1164 17.3373H33.2555C33.0842 17.3373 32.9453 17.1982 32.9453 17.0267V15.1631ZM33.5656 15.4737V16.7161H34.8063V15.4737H33.5656Z",
    fill: "#002C71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9453 18.5796C32.9453 18.4081 33.0842 18.269 33.2555 18.269H35.1164C35.2877 18.269 35.4266 18.4081 35.4266 18.5796V20.4432C35.4266 20.6147 35.2877 20.7538 35.1164 20.7538H33.2555C33.0842 20.7538 32.9453 20.6147 32.9453 20.4432V18.5796ZM33.5656 18.8902V20.1326H34.8063V18.8902H33.5656Z",
    fill: "#FF4D84"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9453 21.9961C32.9453 21.8246 33.0842 21.6855 33.2555 21.6855H35.1164C35.2877 21.6855 35.4266 21.8246 35.4266 21.9961V23.8597C35.4266 24.0312 35.2877 24.1703 35.1164 24.1703H33.2555C33.0842 24.1703 32.9453 24.0312 32.9453 23.8597V21.9961ZM33.5656 22.3067V23.5491H34.8063V22.3067H33.5656Z",
    fill: "#002C71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9453 25.4126C32.9453 25.2411 33.0842 25.1021 33.2555 25.1021H35.1164C35.2877 25.1021 35.4266 25.2411 35.4266 25.4126V27.2762C35.4266 27.4477 35.2877 27.5868 35.1164 27.5868H33.2555C33.0842 27.5868 32.9453 27.4477 32.9453 27.2762V25.4126ZM33.5656 25.7232V26.9656H34.8063V25.7232H33.5656Z",
    fill: "#002C71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9775 15.1631C36.9775 14.9916 37.1164 14.8525 37.2877 14.8525H39.1487C39.32 14.8525 39.4588 14.9916 39.4588 15.1631V17.0267C39.4588 17.1982 39.32 17.3373 39.1487 17.3373H37.2877C37.1164 17.3373 36.9775 17.1982 36.9775 17.0267V15.1631ZM37.5979 15.4737V16.7161H38.8385V15.4737H37.5979Z",
    fill: "#FF4D84"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9775 18.5796C36.9775 18.4081 37.1164 18.269 37.2877 18.269H39.1487C39.32 18.269 39.4588 18.4081 39.4588 18.5796V20.4432C39.4588 20.6147 39.32 20.7538 39.1487 20.7538H37.2877C37.1164 20.7538 36.9775 20.6147 36.9775 20.4432V18.5796ZM37.5979 18.8902V20.1326H38.8385V18.8902H37.5979Z",
    fill: "#002C71"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9775 21.9961C36.9775 21.8246 37.1164 21.6855 37.2877 21.6855H39.1487C39.32 21.6855 39.4588 21.8246 39.4588 21.9961V23.8597C39.4588 24.0312 39.32 24.1703 39.1487 24.1703H37.2877C37.1164 24.1703 36.9775 24.0312 36.9775 23.8597V21.9961ZM37.5979 22.3067V23.5491H38.8385V22.3067H37.5979Z",
    fill: "#FF4D84"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9775 25.4126C36.9775 25.2411 37.1164 25.1021 37.2877 25.1021H39.1487C39.32 25.1021 39.4588 25.2411 39.4588 25.4126V27.2762C39.4588 27.4477 39.32 27.5868 39.1487 27.5868H37.2877C37.1164 27.5868 36.9775 27.4477 36.9775 27.2762V25.4126ZM37.5979 25.7232V26.9656H38.8385V25.7232H37.5979Z",
    fill: "#002C71"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0254 22.3067C43.0254 22.1351 43.1643 21.9961 43.3356 21.9961H44.266C44.4373 21.9961 44.5762 22.1351 44.5762 22.3067C44.5762 22.4782 44.4373 22.6173 44.266 22.6173H43.3356C43.1643 22.6173 43.0254 22.4782 43.0254 22.3067Z",
    fill: "#002C71"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8281 22.3067C27.8281 22.1351 27.967 21.9961 28.1383 21.9961H29.0688C29.2401 21.9961 29.3789 22.1351 29.3789 22.3067C29.3789 22.4782 29.2401 22.6173 29.0688 22.6173H28.1383C27.967 22.6173 27.8281 22.4782 27.8281 22.3067Z",
    fill: "#002C71"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0254 24.6362C43.0254 24.4646 43.1643 24.3256 43.3356 24.3256H44.266C44.4373 24.3256 44.5762 24.4646 44.5762 24.6362C44.5762 24.8077 44.4373 24.9467 44.266 24.9467H43.3356C43.1643 24.9467 43.0254 24.8077 43.0254 24.6362Z",
    fill: "#002C71"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8281 24.6362C27.8281 24.4646 27.967 24.3256 28.1383 24.3256H29.0688C29.2401 24.3256 29.3789 24.4646 29.3789 24.6362C29.3789 24.8077 29.2401 24.9467 29.0688 24.9467H28.1383C27.967 24.9467 27.8281 24.8077 27.8281 24.6362Z",
    fill: "#002C71"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0254 26.9656C43.0254 26.7941 43.1643 26.655 43.3356 26.655H44.266C44.4373 26.655 44.5762 26.7941 44.5762 26.9656C44.5762 27.1372 44.4373 27.2762 44.266 27.2762H43.3356C43.1643 27.2762 43.0254 27.1372 43.0254 26.9656Z",
    fill: "#002C71"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8281 26.9656C27.8281 26.7941 27.967 26.655 28.1383 26.655H29.0688C29.2401 26.655 29.3789 26.7941 29.3789 26.9656C29.3789 27.1372 29.2401 27.2762 29.0688 27.2762H28.1383C27.967 27.2762 27.8281 27.1372 27.8281 26.9656Z",
    fill: "#002C71"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0254 29.2951C43.0254 29.1236 43.1643 28.9845 43.3356 28.9845H44.266C44.4373 28.9845 44.5762 29.1236 44.5762 29.2951C44.5762 29.4666 44.4373 29.6057 44.266 29.6057H43.3356C43.1643 29.6057 43.0254 29.4666 43.0254 29.2951Z",
    fill: "#FF4D84"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8281 29.2951C27.8281 29.1236 27.967 28.9845 28.1383 28.9845H29.0688C29.2401 28.9845 29.3789 29.1236 29.3789 29.2951C29.3789 29.4666 29.2401 29.6057 29.0688 29.6057H28.1383C27.967 29.6057 27.8281 29.4666 27.8281 29.2951Z",
    fill: "#FF4D84"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0254 31.6244C43.0254 31.4529 43.1643 31.3138 43.3356 31.3138H44.266C44.4373 31.3138 44.5762 31.4529 44.5762 31.6244C44.5762 31.796 44.4373 31.935 44.266 31.935H43.3356C43.1643 31.935 43.0254 31.796 43.0254 31.6244Z",
    fill: "#002C71"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8281 31.6244C27.8281 31.4529 27.967 31.3138 28.1383 31.3138H29.0688C29.2401 31.3138 29.3789 31.4529 29.3789 31.6244C29.3789 31.796 29.2401 31.935 29.0688 31.935H28.1383C27.967 31.935 27.8281 31.796 27.8281 31.6244Z",
    fill: "#002C71"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_85_6796",
    x: 0.470703,
    y: 0.472046,
    width: 45.1543,
    height: 56.891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_85_6796"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_85_6796",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_85_6796",
    x: 28.2051,
    y: 0.560791,
    width: 45.3145,
    height: 56.8772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_85_6796"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_85_6796",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_85_6796",
    x: 16.5225,
    y: 0.0753174,
    width: 39.9727,
    height: 54.3762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_85_6796"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_85_6796",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyCard);
export default __webpack_public_path__ + "static/media/company-card.8813db54e5ade2326fcd95bbbbe691b0.svg";
export { ForwardRef as ReactComponent };